// https://github.com/tc39/proposal-global
var $export = require('./_export');

$export($export.S, 'System', { global: require('./_global') });



//////////////////
// WEBPACK FOOTER
// ./apps/guias/~/core-js/modules/es7.system.global.js
// module id = 321
// module chunks = 0